export default {
  establishedSellerTitle: {
    id: 'profile_page_home_tab_title_established_seller',
    defaultMessage: 'Nice to see you, { sellerName }.',
  },
  newSellerTitle: {
    id: 'profile_page_home_tab_title_new_seller',
    defaultMessage: 'Welcome, { sellerName }!',
  },
  toDoLabel: {
    id: 'profile_page_home_tab_to-do-label',
    defaultMessage: 'To do',
  },
  establishedSellerDescription: {
    id: 'profile_page_home_tab_description_established_seller',
    defaultMessage:
      'Let’s confirm your information is up to date to keep your business running smoothly on Back Market.',
  },
  newSellerDescription: {
    id: 'profile_page_home_tab_description_new_seller',
    defaultMessage: 'Let’s roll up our sleeves and get started.',
  },
  contactDetailsSectionTitle: {
    id: 'profile_page_home_tab_contact_details_section_title',
    defaultMessage: 'Contact details',
  },
  legalDetailsSectionTitle: {
    id: 'profile_page_home_tab_legal_details_section_title',
    defaultMessage: 'Legal details and documents',
  },
  businessDetailsSectionTitle: {
    id: 'profile_page_home_tab_business_details_section_title',
    defaultMessage: 'Business details',
  },
  userPermissionsSectionTitle: {
    id: 'profile_page_home_tab_user_permissions_section_title',
    defaultMessage: 'User permissions',
  },
  contactDetailsSectionEstablishedSellerDescription: {
    id: 'profile_page_home_tab_contact_details_section_established_seller_description',
    defaultMessage: 'Make sure we’re contacting the right people on your team.',
  },
  legalDetailsSectionEstablishedSellerDescription: {
    id: 'profile_page_home_tab_legal_details_section_established_seller_description',
    defaultMessage: 'Make any changes or upload new legal documents here.',
  },
  businessDetailsSectionEstablishedSellerDescription: {
    id: 'profile_page_home_tab_business_details_section_established_seller_description',
    defaultMessage: 'Make any changes to your business name or address here.',
  },
  contactDetailsSectionNewSellerDescription: {
    id: 'profile_page_home_tab_contact_details_section_new_seller_description',
    defaultMessage: 'Add your points of contact to never miss a beat.',
  },
  legalDetailsSectionNewSellerDescription: {
    id: 'profile_page_home_tab_legal_details_section_new_seller_description',
    defaultMessage:
      'We’ll walk you through everything you need to start selling on Back Market.',
  },
  businessDetailsSectionNewSellerDescription: {
    id: 'profile_page_home_tab_business_details_section_new_seller_description',
    defaultMessage: 'Make sure we got these details right the first time.',
  },
  confirmLinkLabel: {
    id: 'profile_page_home_tab_confirm_link_label',
    defaultMessage: 'Confirm details',
  },
  addLinkLabel: {
    id: 'profile_page_home_tab_add_link_label',
    defaultMessage: 'Add details',
  },
  editLinkLabel: {
    id: 'profile_page_home_tab_edit_link_label',
    defaultMessage: 'Edit details',
  },
  userPermissionsDetails: {
    id: 'profile_page_home_tab_user_permissions_details',
    defaultMessage:
      'Add new users to your Back Office or delete existing ones.',
  },
  userPermissionsLinkLabel: {
    id: 'profile_page_home_tab_user_permissions_link_label',
    defaultMessage: 'Manage users',
  },
}
